import { BookingService } from '@common/lib/api';
import * as booking from './types';

const actions = {
  async [booking.CREATE_BOOKING](context, params) {
    console.log('CREATE_BOOKING');
    console.log(params);

    const { data } = await BookingService.add(params);
    console.log(data);
    return data;
  },
  async [booking.FETCH_BOOKING](context, params) {
    const { data } = await BookingService.getById(params);
    context.commit(booking.SET_BOOKING, data);

    return data;
  },
  async [booking.FETCH_BOOKING_LIST](context) {
    console.log('FETCH_BOOKING_LIST');

    const { data } = await BookingService.getList();
    context.commit(booking.SET_BOOKING_LIST, data);
    return data;
  },
  async [booking.UPDATE_BOOKING](context, params) {
    console.log('UPDATE_BOOKING');

    const { data } = await BookingService.modifyById(params);
    context.commit(booking.SET_BOOKING, data);
    return data;
  },
  async [booking.DELETE_BOOKING](context, params) {
    const { data } = await BookingService.removeById(params);

    return data;
  },
};

export default actions;
